module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"hideError":"Hide errors"},"fr":{"hideError":"Cacher les erreurs"}}')
  delete Component.options._Ctor
}
